import { render, staticRenderFns } from "./TemplateSelectionStage.vue?vue&type=template&id=380f8a8c&scoped=true"
import script from "./TemplateSelectionStage.vue?vue&type=script&lang=js"
export * from "./TemplateSelectionStage.vue?vue&type=script&lang=js"
import style0 from "./TemplateSelectionStage.vue?vue&type=style&index=0&id=380f8a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380f8a8c",
  null
  
)

export default component.exports